import { render, staticRenderFns } from "./add-tags.vue?vue&type=template&id=b9d701b0&scoped=true"
import script from "./add-tags.vue?vue&type=script&lang=js"
export * from "./add-tags.vue?vue&type=script&lang=js"
import style0 from "./add-tags.vue?vue&type=style&index=0&id=b9d701b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d701b0",
  null
  
)

export default component.exports